// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__38dbo","errorLogs":"styles_errorLogs__3alAL"};